<template>
	<div v-title title="订单详情" class="order-detail-page">
		<div class="top-bg"></div>
		<!-- 状态 -->
		<div class="status-box flex">
			<!-- 待付款 -->
			<img class="icon" v-if="!isShouHou && (detail.status == 0 || detail.status == 1)"
				src="@/assets/images/order/icon_s_t.png" alt="" />
			<!-- 已付款,待发货 -->
			<img class="icon" v-else-if="!isShouHou && detail.status == 2" src="@/assets/images/order/icon_s_f.png" alt="" />
			<!-- 已发货 -->
			<img class="icon" v-else-if="!isShouHou && detail.status == 3" src="@/assets/images/order/icon_s_c.png" alt="" />
			<!-- 交易成功 -->
			<img class="icon" v-else-if="!isShouHou && detail.status == 4" src="@/assets/images/order/icon_s_o.png" alt="" />
			<!-- 无效订单 -->
			<img class="icon" v-else-if="!isShouHou && detail.status == 5" src="@/assets/images/order/icon_s_e.png" alt="" />
			<!-- 售后 等待卖家确认 -->
			<img class="icon" v-else-if="isShouHou && returnDetail.status == 0" src="@/assets/images/order/icon_s_t.png"
				alt="" />
			<!-- 售后 退货中 -->
			<img class="icon" v-else-if="isShouHou && returnDetail.status == 1" src="@/assets/images/order/icon_s_f.png"
				alt="" />
			<!-- 售后 退款申请中 -->
			<img class="icon" v-else-if="isShouHou && returnDetail.status == 2" src="@/assets/images/order/icon_s_f.png"
				alt="" />
			<!-- 售后 已退款 -->
			<img class="icon" v-else-if="isShouHou && returnDetail.status == 3" src="@/assets/images/order/icon_s_r.png"
				alt="" />
			<!-- 售后 已拒绝 -->
			<img class="icon" v-else-if="isShouHou && returnDetail.status == 4" src="@/assets/images/order/icon_s_e.png"
				alt="" />
			<!-- 售后 已取消 -->
			<img class="icon" v-else-if="isShouHou && returnDetail.status == 5" src="@/assets/images/order/icon_s_e.png"
				alt="" />

			<div class="text-row flex-col" v-if="isShouHou">
				<span class="text1" v-if="returnDetail.status == 1 && !returnDetail.deliveryCompanyId">请退货并填写物流信息</span>
				<span class="text1" v-else>{{ returnDetail.status | shouhouStatus }}</span>
				<span class="text2 flex" v-if="returnDetail.status == 1 && !returnDetail.deliveryCompanyId">
					还剩<van-count-down class="down" :time="returnTime" format="DD 天 HH 时 mm 分" />自动确认
				</span>
			</div>
			<div class="text-row flex-col" v-else>
				<span class="text1">{{ detail.status | orderDetailStatus }}</span>
				<span class="text2" v-if="!isShouHou && detail.status == 2">等待卖家发货</span>
				<span class="text2 flex" v-if="!isShouHou && detail.status == 3">
					还剩<van-count-down class="down" :time="confirmTime" format="DD 天 HH 时 mm 分" />自动确认
				</span>
				<span class="text2 flex" v-if="!isShouHou && (detail.status == 0 || detail.status == 1)">
					<van-count-down class="down" :time="closeTime" format="mm 分 ss 秒" />后订单关闭
				</span>
			</div>
			<span class="flex1"></span>
		</div>
		<!-- 地址 -->
		<div class="box addr-box" v-if="detail.status == 2 && !isShouHou && detail.deliveryType == 1">
			<div class="name-tel">
				<span class="name">{{ detail.receiverName }}</span>
				<span class="tel">{{ detail.receiverPhone }}</span>
			</div>
			<img class="icon-addr" src="@/assets/images/product/icon_addr.png" />
			<div class="addr-d">{{ detail.receiverProvince }}
				{{ detail.receiverCity }}
				{{ detail.receiverRegion }}
				{{ detail.receiverStreet }}
				{{ detail.receiverDetailAddress }}</div>
		</div>
		<!-- 物流信息 -->
		<div class="box wl-list-box" v-if="(detail.status == 3 || detail.status == 4) &&
				!isShouHou &&
				detail.deliveryType == 1">
			<van-tabs v-if="trackShortList.length > 1" v-model="wlActive" :offset-top="0" color="#00754A" line-width="10px">
				<van-tab :title="`物流${index + 1}`" v-for="(item, index) in trackShortList" :key="index">
				</van-tab>
			</van-tabs>
			<van-steps active-color="#00754A" direction="vertical" :active="0">
				<van-step v-for="(item, index) in trackShortList[wlActive]" :key="index">
					<div class="flex">
						<span style="font-size: 14px;">{{ item.statusDesc }}</span>
						<span class="flex1"></span>
						<span style="font-size: 11px;" v-if="index == 0" @click="goToWuliuDetail()">详细信息</span>
						<img style="width: 12px; height: 12px;" v-if="index == 0" src="@/assets/images/order/icon_more_g.png"
							@click="goToWuliuDetail()" />
					</div>
					<div style="margin: 3px 0;">{{ item.nodeTimeFmt }}</div>
					<div style="font-size: 12px;">
						{{ item.nodeContext }}
					</div>
				</van-step>
			</van-steps>
		</div>
		<!-- 退回券/积分信息 -->
		<div class="box back-box" v-if="isShouHou && returnDetail.status == 3" style="min-height: 12vh">
			<div class="line-key-val">
				<span class="line-key">退回平台优惠券</span>
				<div class="flex1"></div>
				<span class="line-val">¥{{ returnDetail.returnChannelRpktRducAmt | price }}</span>
			</div>
			<div class="line-key-val">
				<span class="line-key">返回店铺优惠券</span>
				<div class="flex1"></div>
				<span class="line-val">¥{{ returnDetail.returnCouponAmt | price }}</span>
			</div>
			<div class="line-key-val">
				<span class="line-key">返回积分</span>
				<div class="flex1"></div>
				<span class="line-val">¥{{ returnDetail.returnChannelPntDsctAmt | price }}</span>
			</div>
		</div>
		<!-- 商品 -->
		<div class="box goods-box">
			<div class="goods-title" v-if="isShouHou">退款信息</div>
			<div class="line-1 flex" v-else>
				<img class="icon" src="@/assets/images/order/icon_shop.png" alt="" />
				<span class="title" @click="$router.push('/')">{{ shop.invoiceProvideCompany }}</span>
				<span class="flex1"></span>
			</div>
			<div class="line-2 flex" @click="$router.push('/productDetail?publishId=' + detail.orderItemList[0].productId)">
				<img class="img" :src="detail.orderItemList[0].productPic" alt="" />
				<div class="title-g">
					<div class="title">
						{{ detail.orderItemList[0].productName }}
					</div>
					<div class="g">
						{{ detail.orderItemList[0].productAttrStr }}
					</div>
				</div>
				<span class="flex1"></span>
				<div class="price-box">
					<span class="price">¥{{ detail.orderItemList[0].productPrice }}</span>
					<span class="price-num">x{{ detail.orderItemList[0].productQuantity }}</span>
				</div>
			</div>
			<div class="line-3 flex" v-if="!isShouHou">
				<span class="flex1"></span>
				<div class="btn grey" v-if="detail.status == 2 && detail.isReturn == 0" @click="applayShouhou(1)">申请退款</div>
				<div class="btn" v-if="(detail.status === 3 || detail.status == 4) && detail.canReturn === 1
				" @click="applayShouhou(0)">申请售后</div>
			</div>
			<div class="line-3 flex" v-if="detail.isReturn == 1">
				<span class="flex1"></span>
				<div class="btn grey" @click="gotoShouHou">{{
				detail.isReturn == 1 && detail.returnStatus == 3
					? '退款成功'
					: '退款中'
			}}</div>
			</div>
			<div class="line"></div>
			<section v-if="!isShouHou">
				<div class="line-key-val">
					<span class="line-key">商品总价</span>
					<div class="flex1"></div>
					<span class="line-val red">¥{{ detail.totalAmount }}</span>
				</div>
				<div class="line-key-val">
					<span class="line-key">运费</span>
					<div class="flex1"></div>
					<span class="line-val">¥{{ detail.freightAmount }}</span>
				</div>
				<div class="line-key-val">
					<span class="line-key">平台优惠券</span>
					<div class="flex1"></div>
					<span class="line-val">- ¥{{ detail.channelRpktRducAmt }}</span>
				</div>
				<div class="line-key-val">
					<span class="line-key">店铺优惠券</span>
					<div class="flex1"></div>
					<span class="line-val">¥{{ detail.couponAmount }}</span>
				</div>
				<div class="line-key-val">
					<span class="line-key">积分抵扣</span>
					<div class="flex1"></div>
					<span class="line-val">- ¥{{ detail.channelPntDsctAmt }}</span>
				</div>
				<div class="line-key-val">
					<span class="line-key">{{
				detail.status != 0 && detail.status != 1 && detail.status != 5
					? '实付款'
					: '需付款'
			}}</span>
					<div class="flex1"></div>
					<span class="line-val red" v-if="detail.status == 0 || detail.status == 1">
						¥{{
				detail.payAmount | price
			}}
					</span>
					<span class="line-val red" v-else-if="detail.status == 5">
						¥{{
				(detail.payAmount -
					detail.channelRpktRducAmt -
					detail.channelPntDsctAmt)
				| price
			}}
					</span>
					<span class="line-val red" v-else>{{ detail.channelPayAmt | price }}</span>
				</div>
			</section>
			<section v-if="isShouHou">
				<div class="line-key-val">
					<span class="line-key">退款原因</span>
					<div class="flex1"></div>
					<span class="line-val">{{ returnDetail.returnReason }}</span>
				</div>
				<div class="line-key-val">
					<span class="line-key">退款金额</span>
					<div class="flex1"></div>
					<span class="line-val">¥{{ returnDetail.returnAmt | price }}</span>
				</div>
				<div class="line-key-val" v-if="returnDetail.status == 3">
					<span class="line-key">申请件数</span>
					<div class="flex1"></div>
					<span class="line-val">{{ returnDetail.returnQty }}</span>
				</div>
				<div class="line-key-val" v-if="returnDetail.status == 3">
					<span class="line-key">申请时间</span>
					<div class="flex1"></div>
					<span class="line-val">{{ returnDetail.createTime | fmtTimeStamp }}</span>
				</div>
				<div class="line-key-val" v-if="returnDetail.status == 3">
					<span class="line-key">退款编号</span>
					<div class="flex1"></div>
					<span class="line-val">{{ returnDetail.code }}</span>
					<img class="icon" @click="copy(returnDetail.code)" src="@/assets/images/order/icon_copy.png" alt="" />
				</div>
				<div class="line-key-val" v-if="returnDetail.status != 3">
					<span class="line-key">返回平台优惠券</span>
					<div class="flex1"></div>
					<span class="line-val">¥{{ returnDetail.returnChannelRpktRducAmt | price }}</span>
				</div>
				<div class="line-key-val" v-if="returnDetail.status != 3">
					<span class="line-key">返回店铺优惠券</span>
					<div class="flex1"></div>
					<span class="line-val">¥{{ returnDetail.returnCouponAmt | price }}</span>
				</div>
				<div class="line-key-val" v-if="returnDetail.status != 3">
					<span class="line-key">返回积分</span>
					<div class="flex1"></div>
					<span class="line-val">¥{{ returnDetail.returnChannelPntDsctAmt | price }}</span>
				</div>
				<div class="line-key-val" v-if="returnDetail.status != 3">
					<span class="line-key">寄回地址</span>
					<div class="flex1"></div>
					<span class="line-val" v-if="returnDetail.companyAddress">
						{{ returnDetail.companyAddress.province }}
						{{ returnDetail.companyAddress.city }}
						{{ returnDetail.companyAddress.region }}
						{{ returnDetail.companyAddress.street }}
						{{ returnDetail.companyAddress.detailAddress }}
						{{ returnDetail.companyAddress.name }}
						{{ returnDetail.companyAddress.phone }}
					</span>
				</div>
			</section>
		</div>
		<!-- 单号信息 -->
		<div class="box no-box">
			<div class="line-key-val">
				<span class="line-key">订单编号</span>
				<div class="flex1"></div>
				<span class="line-val"> {{ detail.orderSn }}</span>
				<img class="icon" @click="copy(detail.orderSn)" src="@/assets/images/order/icon_copy.png" alt="" />
			</div>
			<div class="line-key-val" v-if="detail.channelOrderId">
				<span class="line-key">买单吧订单编号</span>
				<div class="flex1"></div>
				<span class="line-val"> {{ detail.channelOrderId }}</span>
				<img class="icon" @click="copy(detail.channelOrderId)" src="@/assets/images/order/icon_copy.png" alt="" />
			</div>
			<div class="line-key-val">
				<span class="line-key">下单时间</span>
				<div class="flex1"></div>
				<span class="line-val">{{ detail.createTime | fmtTimeStamp }}</span>
			</div>
		</div>
		<!-- 订单服务 -->
		<div class="box order-serve-box" v-if="!isShouHou">
			<span class="title">订单服务</span>
			<div class="order-line flex">
				<img class="order-line-icon-16" src="@/assets/images/product/icon_serve.png" />
				<span class="order-line-icon-text">7天无理由退换</span>
				<span class="flex1"></span>
				<span class="order-line-text-grey" @click="fuwushuomingshow = !fuwushuomingshow">查看服务</span>
				<img class="order-line-icon-12" src="@/assets/images/product/icon_more.png"
					@click="fuwushuomingshow = !fuwushuomingshow" />
			</div>
		</div>
		<!-- 退货物流填写 -->
		<div class="box wl-box" v-if="isShouHou &&
				returnDetail.status == 1 &&
				returnDetail.deliverySn === undefined
				">
			<div class="line-key-val">
				<span class="line-key">请选择物流公司</span>
				<div class="flex1"></div>
				<span class="line-val" @click="showPicker = !showPicker">{{ delveryForm.delveryCompanyName || '请选择' }}</span>
			</div>
			<div class="line-key-val">
				<span class="line-key">物流单号</span>
				<div class="flex1"></div>
				<input class="line-val val-input" type="text" v-model="delveryForm.delverySn" placeholder="请输入物流单号">
			</div>
			<div class="btn-green" @click="confirmWuliu">
				确定
			</div>
		</div>
		<!-- 底部按钮组 -->
		<div class="btn-box flex">
			<div class="btn" @click="kefushow = !kefushow">联系客服</div>
			<span class="flex1"></span>
			<div class="btn ml" v-if="!isShouHou && detail.status != 5" @click="goToFapiao">{{ detail.billMemberStatus == 1 ?
				'查看发票' : '申请发票' }}</div>
			<div class="btn ml" v-if="!isShouHou && (detail.status == 0 || detail.status == 1)" @click="cancelOrder">取消订单
			</div>
			<div class="btn ml" v-if="!isShouHou &&
				(detail.status == 3 || detail.status == 4) &&
				detail.deliveryType == 1" @click="goToWuliuDetail">查看物流
			</div>
			<div class="btn ml" v-if="detail.returnStatus == 0" @click="cancelReturnApply">撤销申请</div>
			<div class="btn ml green" @click="payNow" v-if="!isShouHou &&
				(detail.status == 0 || detail.status == 1) &&
				detail.showPay">
				立即支付
			</div>
			<div class="btn ml green" v-if="!isShouHou && detail.status == 3 && detail.isReturn == 0"
				@click="receiveShow = !receiveShow">
				确认收货
			</div>
		</div>
		<!-- 客服--弹框 -->
		<van-action-sheet class="sheet-dialog linear-gradient" v-model="kefushow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">云卡商城平台</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="kefushow = !kefushow" />
			</div>
			<img class="bg-serve" src="@/assets/images/product/bg_serve.png" />
			<div class="items">
				<div class="item" @click="phoneNumber">
					<span class="text">客服电话</span>
					<span class="time">{{ shop.customerServiceTime }}</span>
					<img class="icon" src="@/assets/images/product/icon_tel.png" />
				</div>
				<div class="item" @click="phoneNumber2">
					<span class="text">在线客服</span>
					<span class="time"> {{ shop.onlineServiceTime }} </span>
					<img class="icon" src="@/assets/images/product/icon_net.png" />
				</div>
			</div>
		</van-action-sheet>
		<!-- 服务说明--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="fuwushuomingshow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">服务说明</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="fuwushuomingshow = false" />
			</div>
			<div class="icon-val">
				<img class="icon" src="@/assets/images/product/icon_serve.png" />
				<span class="val">7天无理由退换</span>
			</div>
			<div class="explain">
				此商品支持七天无理由退换货，在不影响商品二次销售的情况下，支持客户承担运费退换货。
			</div>
			<div class="btn" @click="fuwushuomingshow = false">我知道了</div>
		</van-action-sheet>
		<!-- 确认收货--弹框 -->
		<van-action-sheet class="sheet-dialog" v-model="receiveShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">确认收货</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="receiveShow = false" />
			</div>
			<div class="sheet-goods-box">
				<div class="line-1 flex">
					<img class="icon" src="@/assets/images/order/icon_shop.png" alt="" />
					<span class="title">{{ shop.invoiceProvideCompany }}</span>
					<span class="flex1"></span>
				</div>
				<div class="line-2 flex">
					<img class="img" :src="detail.orderItemList[0].productPic" alt="" />
					<div class="title-g">
						<div class="title">
							{{ detail.orderItemList[0].productName }}
						</div>
						<div class="g">
							{{ detail.orderItemList[0].productAttrStr }}
						</div>
					</div>
					<span class="flex1"></span>
					<div class="price-box">
						<span class="price">¥{{ detail.orderItemList[0].productPrice }}</span>
						<span class="price-num">x{{ detail.orderItemList[0].productQuantity }}</span>
					</div>
				</div>
				<div class="line-3">
					<span class="text f13">实付款</span>
					<span class="text f10">￥</span>
					<span class="text f16">¥{{ detail.payAmount | price }}</span>
				</div>
			</div>
			<div class="h120"></div>
			<div class="next-box">
				<div class="next-step">
					为保证您的售后权益,请收到商品确认无误后再确认收货
				</div>
				<div class="next-btn" @click="confirmReceive">
					确定
				</div>
			</div>
		</van-action-sheet>
		<!-- 退款--弹框 -->
		<van-action-sheet class="sheet-dialog" @close="closeReturnApply" v-model="tuikuanShow">
			<div class="sheet-title">
				<div class="flex"></div>
				<div class="text">确认退款信息</div>
				<img class="icon" src="@/assets/images/product/icon_close.png" @click="tuikuanShow = false" />
			</div>
			<div v-show="tuikuanStep1">
				<div class="sheet-goods-box" style="height: 120px;">
					<div class="line-1 flex">
						<span class="title">{{ detail.createTime | fmtTimeStamp }}</span>
						<span class="flex1"></span>
						<span style="color: #FF4E4E; font-size: 12px;">退款</span>
					</div>
					<div class="line-2 flex">
						<img class="img" :src="detail.orderItemList[0].productPic" alt="" />
						<div class="title-g flex1">
							<div class="title" style="width: 238px">
								{{ detail.orderItemList[0].productName }}
							</div>
							<div class="g" style="width: 238px; margin-top: 6px;">
								{{ detail.orderItemList[0].productAttrStr }}
							</div>
						</div>
					</div>
				</div>
				<div class="key-val input-key-val">
					<span class="key">选择退款方式</span>
					<div class="val-tags">
						<span :class="radio == '1' ? 'val-tag val-tag-s' : 'val-tag'" @click="checkRadio(1)">仅退款</span>
						<span :class="radio == '0' ? 'val-tag val-tag-s' : 'val-tag'" @click="checkRadio(0)">退货退款</span>
					</div>
				</div>
				<div class="key-val input-key-val" v-if="radio == 0">
					<span class="sku-key">请选择退货数量</span>
					<div class="flex1"></div>
					<van-stepper class="num-step" disable-input input-width="40px" button-size="32px"
						v-model="returnApplyForm.returnQuantity" @change="stepChange" :max="tuikuanInfo.maxReturnQuantity" />
				</div>
				<div class="key-val input-key-val">
					<span class="key">填写退款金额</span>
					<span class="flex1"></span>
					<van-field class="val-input" type="text" :disabled="!isShouHou && detail.status == 2 || radio == 0"
						:formatter="formatter" format-trigger="onBlur" v-model="returnApplyForm.returnAmount"
						:placeholder="`最多${tuikuanInfo.maxReturnQuantity}件，¥${tuikuanInfo.maxReturnAmount}（含运费¥${tuikuanInfo.returnFreight}）`" />
				</div>
				<div class="btn" @click="tuikuanNext">下一步</div>
			</div>
			<div v-show="tuikuanStep2">
				<div class="reason-list">
					<div class="reason-item flex" v-for="item in returnReasonList" :key="item.name"
						@click="returnApplyForm.returnReason = item.name">
						<img v-if="returnApplyForm.returnReason == item.name" class="icon-d"
							src="@/assets/images/product/icon_default.png" alt="" />
						<img v-else class="icon-d" src="@/assets/images/product/icon_default_no.png" alt="" />
						<span class="text">
							{{ item.name }}
						</span>
						<span class="flex1">
						</span>
					</div>
				</div>
				<div class="btn" @click="tuikuanSubmit">提交申请</div>
			</div>
		</van-action-sheet>

		<van-popup v-model="showPicker" position="bottom">
			<van-picker ref="picker" show-toolbar :columns="columns" value-key="name" @confirm="onConfirm"
				@cancel="showPicker = false" />
		</van-popup>
		<MyDialog :dialogForm="dialogForm" />

		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/orderDetail"></div>
	</div>
</template>

<script>
import MyDialog from '@/components/MyDialog.vue'
import { Toast } from 'vant'

export default {
	name: 'Order',
	components: {
		MyDialog,
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			wlActive: 0,
			radio: '1',
			tuikuanInfo: {},
			shop: {
				name: '',
				logo: '',
				invoiceProvideCompany: '',
				customerServicePhone: '',
				customerServiceTime: '',
				onlineServiceTime: '',
				businessLicense: '',
			},
			value: '',
			active: 1,
			time: 60 * 60 * 1000 * 60,
			returnTime: '',
			closeTime: '',
			confirmTime: '',
			fuwushuomingshow: false,
			receiveShow: false,
			tuikuanShow: false,
			tuikuanStep1: true,
			tuikuanStep2: false,
			kefushow: false,
			tuikuanRadio: '',
			searchForm: {
				orderId: '',
			},
			searchShouHouForm: {
				orderId: '',
			},
			isShouHou: false,
			detail: {
				orderItemList: [{}],
			},
			deliveryCompany: '',
			deliverySn: '',
			trackList: [],
			trackShortList: [],
			text: '',
			returnReasonList: [],
			returnDetail: {
				companyAddress: {},
			},
			returnApplyForm: {
				type: '',
				orderId: '',
				returnReason: '',
				returnQuantity: 1, // 数量
				returnAmount: '', // 金额
			},
			showPicker: false,
			columns: [],
			delveryForm: {
				delveryCompanyId: '',
				delveryCompanyName: '',
				delverySn: '',
				id: '',
			},
		}
	},
	mounted() { },
	created() {
		this.searchForm.orderId = this.$route.query.orderId
		this.returnApplyForm.orderId = this.$route.query.orderId
		if (this.$route.query.isShouHou === 'Y') {
			this.isShouHou = true
			this.searchShouHouForm.orderId = this.$route.query.orderId
			this.delveryForm.id = this.$route.query.returnId
			this.getDetail()
			this.getWuliu()
		} else {
			this.getDetail()
		}
		this.getReturnReason()
		// this.getShopDetail()

		if (this.$route.query.returnId != undefined) {
			this.getReturnDetail()
		}
		this.getShopDetail()
		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		checkRadio(num) {
			this.radio = num
			this.$post('returnApply/preCreate', this.returnApplyForm).then(
				(res) => {
					console.log('/preCreate')
					console.log(res)
					if (res.code === this.GLOBAL.SUCCESS) {
						this.tuikuanShow = true
						this.tuikuanInfo = res.data
						if (!this.isShouHou && this.detail.status == 2) {
							this.returnApplyForm.returnAmount = this.tuikuanInfo.maxReturnAmount
						}
					} else {
						this.$dialog.alert({
							theme: 'round-button',
							message: res.message,
							confirmButtonColor: '#00754A',
						})
					}
				}
			)
		},
		stepChange(num) {
			console.log('num')
			console.log(num)
			this.returnApplyForm.returnAmount = num * +this.detail.orderItemList[0].productPrice
			if (num == this.tuikuanInfo.maxReturnQuantity) {
				this.returnApplyForm.returnAmount += this.tuikuanInfo.returnFreight
			}
		},
		formatter(e) {
			e = e.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
			e = e.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			e = e.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			e = e.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
			e = e.replace(/^\./g, ''); //首位不能输入“.”
			if (e.indexOf(".") < 0 && e != "") {//如果没有小数点，首位不能为0，如01、02...
				e = parseFloat(e);
			}
			return e
		},
		phoneNumber() {
			window.location.href = 'tel://' + this.shop.customerServicePhone
		},
		phoneNumber2() {
			// window.location.href = this.$baseUrl3
			// this.$router.push("/help");
			// this.$refs.content2.click();
			document.getElementById('content').click()
		},
		onConfirm(v) {
			this.showPicker = false
			this.delveryForm.delveryCompanyId = v.id
			this.delveryForm.delveryCompanyName = v.name
		},
		confirmWuliu() {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '确认提交售后信息吗？',
				btnCancelText: '暂不提交',
				btnConfirmText: '确定',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					this.$get(
						'returnApply/delivery/' + this.$route.query.returnId,
						this.delveryForm
					).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast('信息提交成功')
							self.getDetail()
							self.getReturnDetail()
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A',
							})
						}
					})
				}
			}
		},
		closeReturnApply() {
			this.returnApplyForm.returnReason = ''
			this.returnApplyForm.type = ''
			this.tuikuanStep1 = true
			this.tuikuanStep2 = false
		},
		getReturnDetail() {
			this.$get('returnApply/detail/' + this.$route.query.returnId, {}).then(
				(res) => {
					console.log(res)
					if (res.code === this.GLOBAL.SUCCESS) {
						this.returnDetail = res.data

						let d1 = new Date(this.returnDetail.autoCloseTime) //已知时间戳
						let d2 = new Date() //当前时间戳
						this.returnTime = parseInt(d1 - d2)
					} else {
						this.$dialog.alert({
							theme: 'round-button',
							message: res.message,
							confirmButtonColor: '#00754A',
						})
					}
				}
			)
		},
		getReturnReason() {
			this.$get('returnApply/getReturnReason', {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.returnReasonList = res.data
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A',
					})
				}
			})
		},
		getWuliu() {
			this.$get('logistics/listLogisticCompany', {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.columns = res.data
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A',
					})
				}
			})
		},
		applayShouhou(v) {
			if (v == 1) {
				this.text = '退款'
			} else {
				this.text = '退货退款'
			}
			this.radio = v + ''
			this.returnApplyForm.type = v
			this.returnApplyForm.orderId = this.detail.id
			this.returnApplyForm.returnQuantity = 1
			this.$post('returnApply/preCreate', this.returnApplyForm).then(
				(res) => {
					console.log('/preCreate')
					console.log(res)
					if (res.code === this.GLOBAL.SUCCESS) {
						this.tuikuanShow = true
						this.tuikuanInfo = res.data
						if (!this.isShouHou && this.detail.status == 2) {
							this.returnApplyForm.returnAmount = this.tuikuanInfo.maxReturnAmount
						}
					} else {
						this.$dialog.alert({
							theme: 'round-button',
							message: res.message,
							confirmButtonColor: '#00754A',
						})
					}
				}
			)

		},
		gotoShouHou() {
			this.$router.push({
				path: '/orderDetail',
				query: {
					orderId: this.detail.id,
					returnId: this.detail.returnId,
					isShouHou: 'Y',
				},
			})
			this.$router.go(0)
		},
		copy(text) {
			Toast('已复制')

			// 创建元素
			if (!document.getElementById('copyTarget')) {
				const copyTarget = document.createElement('input')
				copyTarget.setAttribute(
					'style',
					'position:fixed;top:0;left:0;opacity:0;z-index:-1000;'
				)
				copyTarget.setAttribute('id', 'copyTarget')
				document.body.appendChild(copyTarget)
			}

			// 复制内容
			const input = document.getElementById('copyTarget')
			input.value = text
			input.select()
			document.execCommand('copy')
			// alert('复制成功')
		},

		getDetail() {
			let self = this
			let id = ''
			let url = ''
			if (this.$route.query.orderId) {
				id = this.$route.query.orderId
				url = 'order/detail/'
			} else if (!this.$route.query.orderId && this.$route.query.orderCode) {
				id = this.$route.query.orderCode
				url = 'order/detailByOrderNo/'
			}
			this.$get(url + id, {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.detail = res.data
					this.detail.orderItemList.forEach((item) => {
						let arr = JSON.parse(item.productAttr)
						console.log(arr)
						let str = ''
						arr.forEach((item2) => {
							str += item2.key + ':' + item2.value + ';'
						})
						item.productAttrStr = str
					})

					let d1 = new Date(this.detail.expiryTime) //已知时间戳
					let d2 = new Date() //当前时间戳
					this.closeTime = parseInt(d1 - d2)

					if (this.detail.status === 0 || this.detail.status === 1) {
						if (this.closeTime > 0) {
							this.$set(this.detail, 'showPay', true)
						}

						setTimeout(function () {
							self.$set(self.detail, 'showPay', false)
						}, self.closeTime)
					}

					if (!this.isShouHou && this.detail.status == 3) {
						let d3 = new Date(this.detail.autoConfirmTime) //已知时间戳
						this.confirmTime = parseInt(d3 - d2)
					}

					if (this.detail.deliverySn) {
						this.queryTrackList()
					}
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A',
					})
				}
			})
		},
		queryTrackList() {
			this.deliveryCompany = this.detail.deliveryCompany
			this.deliverySn = this.detail.deliverySn

			this.$get('order/trackList/' + this.detail.id, {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.trackList = []
					this.trackShortList = []

					res.data.forEach((items) => {
						console.log('----------------items');
						console.log(items);
						let arr = []
						items.forEach((item) => {
							let d = new Date(item.nodeTime)
							item.nodeTimeFmt = this.$parseTime(d)
						})
						if (items.length === 1) {
							arr = items
						} else if (items.length > 1) {
							arr.push(items[0])
							arr.push(items[items.length - 1])
						}
						this.trackShortList.push(arr)
					})
					console.log('-----------trackShortList-----');
					console.log(this.trackShortList);

					this.trackList = res.data[0]
					// this.trackList.forEach((item) => {
					// 	let d = new Date(item.nodeTime)
					// 	item.nodeTimeFmt = this.$parseTime(d)
					// })

					// if (this.trackList.length === 1) {
					// 	this.trackShortList = this.trackList
					// } else if (this.trackList.length > 1) {
					// 	this.trackShortList.push(this.trackList[0])
					// 	this.trackShortList.push(this.trackList[this.trackList.length - 1])
					// }
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A',
					})
				}
			})
		},

		submit() { },
		onClickLeft() {
			if (this.$route.query.returnId != undefined) {
				this.$router.push('/shouhouList')
			} else {
				this.$router.push({
					path: '/orderList',
					query: {
						status: this.$route.query.status,
					},
				})
			}
		},
		goToDetail() { },
		goToWuliuDetail(i = 0) {
			this.$router.push({
				path: '/wuliuDetail',
				query: {
					orderId: this.detail.id,
					i: this.wlActive,
					fromPage: 'orderDetail',
					status: this.$route.query.status,
				},
			})
		},
		changeAddress() {
			// this.$router.push({
			//     path: '/orderAddress',
			//     query: {
			//         orderId: this.detail.id,
			//         formOrderDetail: 'Y'
			//     }
			// })
		},
		goToFapiao() {
			if (this.detail.billMemberStatus === 2) {
				this.$router.push({
					path: '/orderFapiaoList',
					query: {
						orderId: this.detail.id,
						status: this.$route.query.status,
					},
				})
			} else {
				this.$router.push({
					path: '/orderFapiao',
					query: {
						orderId: this.detail.id,
						status: this.$route.query.status,
					},
				})
			}
		},
		confirmReceive() {
			this.receiveShow = false

			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否确认收货？',
				btnCancelText: '暂不收货',
				btnConfirmText: '确定',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					this.$get('order/confirmReceiveOrder/' + this.detail.id, {}).then(
						(res) => {
							console.log(res)
							if (res.code === this.GLOBAL.SUCCESS) {
								self.$toast('确认收货成功')
								self.getDetail()
							} else {
								this.$dialog.alert({
									theme: 'round-button',
									message: res.message,
									confirmButtonColor: '#00754A',
								})
							}
						}
					)
				}
			}
		},
		cancelOrder() {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否取消该订单？',
				btnCancelText: '暂不取消',
				btnConfirmText: '确定',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					this.$get('order/cancelOrder/' + this.detail.id, {}).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast(res.message)
							self.getDetail()
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A',
							})
						}
					})
				}
			}
		},
		cancelReturnApply() {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否撤销售后申请？',
				btnCancelText: '暂不撤销',
				btnConfirmText: '确定',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					this.$get('returnApply/cancel/' + this.detail.returnId, {}).then(
						(res) => {
							console.log(res)
							if (res.code === this.GLOBAL.SUCCESS) {
								self.$toast(res.message)
								self.getDetail()
								if (self.$route.query.returnId != undefined) {
									self.getReturnDetail()
								}
							} else {
								this.$dialog.alert({
									theme: 'round-button',
									message: res.message,
									confirmButtonColor: '#00754A',
								})
							}
						}
					)
				}
			}
		},
		tuikuanNext() {
			if (!+this.returnApplyForm.returnAmount) {
				this.$toast('请填写正确的退款金额')
			} else if (+this.returnApplyForm.returnAmount > this.tuikuanInfo.maxReturnAmount) {
				this.$toast('退款金额最大不能超过' + this.tuikuanInfo.maxReturnAmount)
			} else {
				this.tuikuanStep1 = false
				this.tuikuanStep2 = true
			}
		},
		tuikuanSubmit() {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '确认提交售后信息吗？',
				btnCancelText: '暂不提交',
				btnConfirmText: '确定',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false

					this.returnApplyForm.orderId = this.detail.id
					this.returnApplyForm.type = +this.radio
					this.$post('returnApply/create/', this.returnApplyForm).then(
						(res) => {
							console.log(res)
							if (res.code === this.GLOBAL.SUCCESS) {
								this.tuikuanShow = false
								self.$toast('售后申请提交成功')
								self.getDetail()
							} else {
								this.$dialog.alert({
									theme: 'round-button',
									message: res.message,
									confirmButtonColor: '#00754A',
								})
							}
						}
					)
				}
			}
		},
		getShopDetail() {
			let self = this
			this.$get('setting/sysParam/sys_shop_param').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					self.shop.name = resData.find(
						(i) => i.dictLabel == '商城名称'
					).dictValue
					self.shop.logo = resData.find(
						(i) => i.dictLabel == '商城LOGO'
					).dictValue
					self.shop.invoiceProvideCompany = resData.find(
						(i) => i.dictLabel == '发票提供公司'
					).dictValue
					self.shop.customerServicePhone = resData.find(
						(i) => i.dictLabel == '商城客服电话'
					).dictValue
					self.shop.customerServiceTime = resData.find(
						(i) => i.dictLabel == '商城服务时间'
					).dictValue
					self.shop.onlineServiceTime = resData.find(
						(i) => i.dictLabel == '商城在线服务时间'
					).dictValue
					self.shop.businessLicense = resData.find(
						(i) => i.dictLabel == '营业执照'
					).dictValue
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a',
					})
				}
			})
		},
		payNow() {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否立即支付？',
				btnCancelText: '暂不支付',
				btnConfirmText: '确定',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false

					Toast.loading({
						forbidClick: true,
						loadingType: 'spinner',
					})
					this.$get('order/payment/' + this.detail.id, {})
						.then((res) => {
							console.log(res)

							if (res.code === this.GLOBAL.SUCCESS) {
								if (!res.data.success) {
									window.location.href = res.data.paymentPageUrl
								} else {
									self.$toast(res.message)
								}
							} else {
								this.$dialog.alert({
									theme: 'round-button',
									message: res.message,
									confirmButtonColor: '#00754A',
								})
							}
						})
						.finally(() => {
							Toast.clear()
						})
				}
			}
		},
	},
}
</script>

<style scoped lang="less">
/deep/.van-step--vertical::after {
	border: none;
}

/deep/.van-tabs__wrap {
	height: 30px;
}

.van-tab {
	height: 30px;
}

.down {
	padding: 2px 0;
	// background: rgba(255, 78, 78, 0.06);
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #00754A;
}

// /deep/.van-tabs__line {
// 	bottom: 30px;
// }

.order-detail-page {
	position: relative;
	background: #F7F7F7;
	padding-bottom: 50px;

	.flex {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.flex1 {
			flex: 1;
		}
	}

	.flex-col {
		display: flex;
		flex-direction: column;
	}

	.top-bg {
		width: 375px;
		height: 155px;
		background: linear-gradient(180deg, #E3FFF2 0%, #F7F7F7 100%);
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;
	}

	.status-box {
		padding: 20px 16px 14px;
		position: relative;

		.icon {
			width: 20px;
			height: 20px;
			margin-right: 6px;
		}

		.text1 {
			height: 20px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 16px;
			color: #00754A;
			line-height: 20px;
		}

		.text2 {
			margin-top: 6px;
			height: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #00754A;
			line-height: 14px;
		}
	}

	.box {
		box-sizing: border-box;
		margin: 0 auto 10px;
		width: 355px;
		background: #FFFFFF;
		border-radius: 10px;
		padding: 12px;
		position: relative;


		.line-key-val {
			padding: 8px 0;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: flex-start;
			min-height: 16px;

			.flex1 {
				flex: 1;
			}

			.line-key {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
				line-height: 16px;
			}


			.line-val {
				max-width: 200px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;
				line-height: 16px;
				text-align: right;
			}

			.val-input {
				padding: 0 12px;
				box-sizing: border-box;
				width: 200px;
				border: none;
				height: 16px;
				line-height: 16px;
				background: #fff;
				border-radius: 10px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;
			}

			.val-input::placeholder {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #CCCCCC;
			}


			.red {
				color: #FF4E4E;
			}

			.icon {
				width: 16px;
				height: 16px;
				margin-left: 6px;
			}
		}

		.btn-green {
			margin: 12px 0 0 262px;
			width: 68px;
			height: 30px;
			background: #00754A;
			border-radius: 8px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 12px;
			color: #FFFFFF;
			line-height: 30px;
			text-align: center;
		}
	}

	.wl-list-box {}

	.addr-box {
		margin-top: 0;
		box-sizing: border-box;

		width: 355px;
		height: 60px;
		background: #FFFFFF;
		border-radius: 10px;
		border-radius: 10px;
		position: relative;

		.name-tel {
			height: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: #333333;
			line-height: 16px;
			position: absolute;
			top: 12px;
			left: 12px;

			.tel {
				margin-left: 10px;
				font-weight: 400;
			}
		}

		.icon-addr {
			width: 14px;
			height: 14px;
			position: absolute;
			top: 34px;
			left: 12px;
		}

		.addr-d {
			position: absolute;
			top: 34px;
			left: 30px;
			width: 280px;
			height: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #666666;
			line-height: 14px;
			text-align: left;
			font-style: normal;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

	}

	.goods-box {
		.goods-title {
			height: 22px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #333333;
			line-height: 22px;
		}

		.line-1 {
			height: 22px;

			.icon {
				width: 14px;
				height: 14px;
				margin-right: 4px;
			}

			.title {
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #666666;
				line-height: 14px;
			}



			.down {
				padding: 4px 8px;
				background: rgba(255, 78, 78, 0.06);
				border-radius: 11px;
				font-size: 11px;
				color: #FF4E4E;
			}

			.btn {
				width: 49px;
				height: 22px;
				background: #FF4E4E;
				border-radius: 11px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 11px;
				color: #FFFFFF;
				line-height: 22px;
				text-align: center;
			}

			.text-red {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #FF4E4E;
				line-height: 16px;
			}

			.text-grey {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
				line-height: 16px;
			}
		}

		.line-2 {
			margin: 8px 0 0;
			height: 70px;
			align-items: flex-start;

			.img {
				width: 70px;
				height: 70px;
				border-radius: 6px;
			}

			.title-g {
				margin: 2px 0 0 12px;
				display: flex;
				flex-direction: column;

				.title {
					width: 169px;
					height: 36px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #333333;
					line-height: 18px;
					text-align: left;
					font-style: normal;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}

				.g {
					width: 169px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #999999;
					line-height: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;

				}
			}

			.price-box {
				margin-top: 5px;
				display: flex;
				flex-direction: column;

				.price {
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #333333;
					line-height: 14px;
					text-align: right;
					font-style: normal;
				}

				.price-num {
					margin-top: 4px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #333333;
					line-height: 14px;
					text-align: right;
				}
			}
		}

		.line-3 {
			.btn {
				box-sizing: border-box;
				width: 68px;
				height: 30px;
				border-radius: 8px;
				border: 1px solid #CCCCCC;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #333333;
				line-height: 30px;
				text-align: center;
			}

			.grey {
				color: #999;
			}
		}



		.line {
			margin: 16px 0 7px;
			width: 331px;
			height: 1px;
			background-color: #EEEEEE;
		}


	}

	.no-box {}

	.back-box {}

	.order-serve-box {
		.title {
			height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #333333;
			line-height: 18px;
		}

		.order-line {
			margin-top: 10px;

			.order-line-icon-16 {
				width: 16px;
				height: 16px;
				margin-right: 6px;
			}

			.order-line-icon-text {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #00754A;
				line-height: 16px;
			}

			.order-line-text-grey {
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #999999;
				line-height: 14px;

			}

			.order-line-icon-12 {
				width: 12px;
				height: 12px;
			}
		}
	}

	.btn-box {
		position: fixed;
		left: 0;
		bottom: 0;
		box-sizing: border-box;
		width: 375px;
		height: 46px;
		background: #FFFFFF;
		justify-content: space-between;
		padding: 0 12px;

		.btn {
			margin: 5px 0;
			box-sizing: border-box;
			width: 80px;
			height: 34px;
			border-radius: 8px;
			border: 1px solid #CCCCCC;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			line-height: 34px;
			text-align: center;
		}

		.ml {
			margin-left: 10px;
		}

		.green {
			background: #00754A;
			border: none;
			color: #FFFFFF;
		}
	}

	.sheet-dialog {
		box-sizing: border-box;
		padding: 12px 15px;

		.sheet-title {
			margin-bottom: 20px;
			height: 18px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: space-between;
			align-items: center;
			position: relative;

			.text {
				height: 18px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 15px;
				color: #333333;
				line-height: 18px;
				text-align: center;
				font-style: normal;
			}

			.notice {
				position: absolute;
				top: 0;
				right: 24px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #00754A;
			}

			.icon {
				width: 12px;
				height: 12px;
			}
		}

		.sheet-goods-box {
			width: 345px;
			height: 142px;
			background: #F7F7F7;
			border-radius: 10px;
			box-sizing: border-box;
			margin: 10px auto;
			padding: 8px 12px 12px;
		}

		.line-1 {
			height: 22px;

			.icon {
				width: 14px;
				height: 14px;
				margin-right: 4px;
			}

			.title {
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #666666;
				line-height: 14px;
			}



			.down {
				padding: 4px 8px;
				background: rgba(255, 78, 78, 0.06);
				border-radius: 11px;
				font-size: 11px;
				color: #FF4E4E;
			}

			.btn {
				width: 49px;
				height: 22px;
				background: #FF4E4E;
				border-radius: 11px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 11px;
				color: #FFFFFF;
				line-height: 22px;
				text-align: center;
			}

			.text-red {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #FF4E4E;
				line-height: 16px;
			}

			.text-grey {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
				line-height: 16px;
			}
		}

		.line-2 {
			margin: 8px 0 0;
			height: 70px;
			align-items: flex-start;

			.img {
				width: 70px;
				height: 70px;
				border-radius: 6px;
			}

			.title-g {
				margin: 2px 0 0 12px;
				display: flex;
				flex-direction: column;

				.title {
					width: 169px;
					height: 36px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #333333;
					line-height: 18px;
					text-align: left;
					font-style: normal;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}

				.g {
					width: 169px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #999999;
					line-height: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;

				}
			}

			.price-box {
				margin-top: 5px;
				display: flex;
				flex-direction: column;

				.price {
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #333333;
					line-height: 14px;
					text-align: right;
					font-style: normal;
				}

				.price-num {
					margin-top: 4px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #333333;
					line-height: 14px;
					text-align: right;
				}
			}
		}

		.line-3 {
			margin-top: 6px;
			height: 16px;
			text-align: right;
			font-size: 0;

			.text {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #333333;
				line-height: 16px;
			}

			.f10 {
				font-size: 10px;
			}

			.f13 {
				font-size: 13px;
			}

			.f14 {
				font-size: 14px;
			}

			.f16 {
				font-size: 16px;
			}
		}

		.h120 {
			height: 120px;
		}

		.next-box {
			width: 375px;
			position: absolute;
			left: 0;
			bottom: 10px;
			background-color: #ffffff;

			.next-step {
				width: 375px;
				height: 30px;
				background: rgba(0, 117, 74, 0.06);
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #00754A;
				line-height: 30px;
				text-align: center;
			}

			.next-btn {
				margin: 5px auto;
				width: 355px;
				height: 40px;
				background: #00754A;
				border-radius: 10px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 15px;
				color: #FFFFFF;
				line-height: 40px;
				text-align: center;
			}

			.none {
				background: #CCCCCC;
			}
		}

		.key-val {
			margin: 16px 0;
			padding: 0 2px;
			min-height: 16px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: space-between;
			align-items: flex-start;

			.key {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
				line-height: 16px;
			}

			.val {
				text-align: right;
				width: 240px;
				line-height: 18px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;
			}



			.img {
				width: 149px;
			}
		}

		.input-key-val {
			align-items: center;
			height: 40px;
			position: relative;

			.key {
				width: 80px;

				.red-x {
					color: #FF4E4E;
					font-size: 13px;
				}
			}

			.val-input {
				margin-left: 10px;
				box-sizing: border-box;
				padding: 0 12px;
				flex: 1;
				border: none;
				height: 40px;
				line-height: 40px;
				background: #F7F7F7;
				border-radius: 10px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;

				/deep/input {
					text-align: right;
				}

				.text-addr {
					height: 40px;
					line-height: 40px;
					width: 220px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333;
				}

				.icon-addr-r {
					width: 14px;
					height: 14px;
				}

				.grey {
					color: #CCCCCC;
				}
			}

			.val-input::placeholder {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #CCCCCC;
			}

			.val-input-addr {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: center;
				align-items: center;
			}

			.edit-tt {
				position: absolute;
				top: 14px;
				right: 12px;
				display: flex;
				align-content: center;
				justify-content: center;
				align-items: center;

				.edit-tt-text {
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #00754A;
					line-height: 14px;
				}

				.edit-tt-icon {
					width: 12px;
					height: 12px;
				}

			}

			.val-tags {
				.val-tag {
					margin-left: 10px;
					height: 28px;
					line-height: 28px;
					box-sizing: border-box;
					padding: 12px;
					background: #F7F7F7;
					border-radius: 10px;
					font-weight: 400;
					font-size: 13px;
					color: #CCCCCC;
				}

				.val-tag-s {
					background: rgba(0, 117, 74, 0.06);
					color: #00754A;
				}
			}

			.icon-default {
				width: 16px;
				height: 16px;
			}

			.icon-default-none {
				box-sizing: border-box;
				width: 16px;
				height: 16px;
				background: #FFFFFF;
				border-radius: 4px;
				border: 1px solid #EEEEEE;
			}
		}

		.h100 {
			height: 100px;
		}

		.al {
			justify-content: flex-start
		}

		.reason-list {

			.reason-item {
				height: 36px;

				.icon-d {
					width: 16px;
					height: 16px;
					margin-right: 8px;
				}

				.text {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 16px;
				}
			}
		}


		.icon-val {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: flex-start;
			align-items: center;
			margin-bottom: 5px;

			.icon {
				width: 16px;
				height: 16px;
				margin-right: 6px;
			}

			.val {
				height: 18px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 15px;
				color: #00754A;
				line-height: 18px;
			}
		}

		.explain {
			width: 345px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #666666;
			line-height: 16px;
			margin-bottom: 90px;
		}

		.remark-box {
			background: #F7F7F7;
			border-radius: 10px;
		}

		.addr-list {
			max-height: 350px;
			padding-bottom: 30px;
			overflow: auto;

			.addr-item {
				box-sizing: border-box;
				margin: 10px auto;
				padding: 9px 10px;
				width: 345px;
				background: #F7F7F7;
				border-radius: 6px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #333333;
				line-height: 16px;
			}

			.addr-item-s {
				color: #00754A;
				border: 1px solid #00754A;
				background: rgba(0, 117, 74, 0.06);
			}

			.addr-list-item {
				box-sizing: border-box;
				margin: 10px auto;
				width: 345px;
				height: 60px;
				background: #F7F7F7;
				border-radius: 10px;
				position: relative;

				.name-tel {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #333333;
					line-height: 16px;
					position: absolute;
					top: 12px;
					left: 12px;

					.tel {
						margin-left: 10px;
						font-weight: 400;
					}

					.tag-b {
						margin: 0 6px 0 10px;
						padding: 0 4px;
						height: 16px;
						background: #00754A;
						border-radius: 4px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 11px;
						color: #FFFFFF;
						line-height: 16px;
					}

					.tag {
						padding: 0 4px;
						height: 16px;
						background: rgba(0, 117, 74, 0.06);
						border-radius: 4px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 11px;
						color: #00754A;
						line-height: 16px;
					}
				}

				.icon-addr {
					width: 14px;
					height: 14px;
					position: absolute;
					top: 34px;
					left: 12px;
				}

				.addr-d {
					position: absolute;
					top: 34px;
					left: 30px;
					width: 280px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #666666;
					line-height: 14px;
					text-align: left;
					font-style: normal;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.icon-edit {
					width: 16px;
					height: 16px;
					position: absolute;
					top: 22px;
					right: 14px;
				}

			}

		}

		.tt-list {
			max-height: 350px;
			padding-bottom: 30px;
			overflow: auto;

			.tt-list-item {
				box-sizing: border-box;
				margin: 12px auto;
				width: 345px;
				height: 98px;
				background: #F7F7F7;
				border-radius: 10px;
				position: relative;

				.tt-name-tag {
					position: absolute;
					top: 12px;
					left: 12px;

					.tt-name {
						margin-right: 10px;
						height: 16px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 13px;
						color: #333333;
						line-height: 16px;
					}

					.tt-tag {
						width: 30px;
						height: 16px;
						background: rgba(0, 117, 74, 0.06);
						border-radius: 4px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 11px;
						color: #00754A;
						line-height: 16px;
						text-align: center;
					}

				}

				.tt-cont {
					position: absolute;
					top: 34px;
					left: 12px;
					width: 270px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #333333;
					line-height: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.tt-line {
					position: absolute;
					top: 58px;
					left: 12px;
					width: 323px;
					height: 1px;
					background-color: #EEEEEE;
				}

				.tt-btn {
					width: 48px;
					height: 26px;
					background: #00754A;
					border-radius: 6px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 12px;
					color: #FFFFFF;
					line-height: 26px;
					text-align: center;
					position: absolute;
					top: 16px;
					right: 12px;
				}

				.tt-d {
					display: flex;
					flex-direction: row;
					flex-wrap: nowrap;
					align-content: center;
					justify-content: center;
					align-items: center;
					position: absolute;
					bottom: 12px;
					left: 12px;

					.tt-d-icon {
						width: 16px;
						height: 16px;
					}

					.tt-d-text {
						margin-left: 8px;
						height: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 11px;
						color: #666666;
						line-height: 14px;
					}
				}

				.tt-icon-edit {
					width: 16px;
					height: 16px;
					position: absolute;
					bottom: 12px;
					right: 40px;
				}

				.tt-icon-del {
					width: 16px;
					height: 16px;
					position: absolute;
					bottom: 12px;
					right: 12px;
				}

			}


		}

		.btn {
			margin: 40px auto 0;
			width: 345px;
			height: 40px;
			background: #00754A;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #FFFFFF;
			line-height: 40px;
			text-align: center;
			font-style: normal;
		}

		.no-more {
			margin: 70px auto 130px;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;

			.img {
				width: 110px;
				height: 100px;
			}

			.tips {
				margin-top: 8px;
				height: 14px;
				font-size: 12px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #999999;
				line-height: 14px;
			}
		}

		.list {
			position: relative;
			padding-bottom: 65px;

			.item {
				margin: 0 auto 10px;
				width: 347px;
				height: 88px;

				.img {
					position: absolute;
					width: 100%;
					height: 88px;
					z-index: 0;
				}

				.content-info {
					position: relative;
					width: 100%;
					height: 88px;
					display: flex;

					.dot {
						position: absolute;
						top: 0;
						left: 0;
						width: 49px;
						height: 18px;
						background: linear-gradient(124deg, #ff906d 0%, #ff3d45 100%);
						border-radius: 10px 0px 10px 0px;
						font-size: 11px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #ffffff;
						line-height: 18px;
						text-align: center;
					}

					.left {
						width: 85px;
						display: flex;
						flex-direction: column;
						flex-wrap: nowrap;
						align-content: center;
						justify-content: center;
						align-items: center;

						.price {
							font-size: 0;
							font-family: 'DINA';
							font-weight: bold;
							color: #ff4e4e;
						}

						.condition {
							height: 16px;
							font-size: 11px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #ff4e4e;
							line-height: 16px;
						}
					}

					.content {
						flex: 1;

						.name {
							margin-top: 20px;
							width: 100%;
							height: 32px;
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;
							line-height: 16px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}

						.condition-time {
							display: flex;
							flex-direction: row;
							flex-wrap: nowrap;
							align-content: center;
							justify-content: center;
							align-items: center;
							margin-top: 6px;

							.condition {
								margin-right: 4px;
								height: 9px;
								font-size: 9px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								color: #00754a;
								line-height: 9px;
								white-space: nowrap;
							}

							.time {
								width: 100%;
								height: 12px;
								font-size: 10px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								color: #999999;
								line-height: 12px;
								white-space: nowrap;
							}
						}
					}

					.right {
						width: 87px;
						display: flex;
						align-content: center;
						align-items: center;
						justify-content: center;

						.btn-get {
							width: 64px;
							height: 26px;
							background: #00754a;
							border-radius: 6px;
							font-size: 12px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #ffffff;
							line-height: 26px;
							text-align: center;
						}

						.img {
							width: 57px;
							height: 44px;
							position: absolute;
							top: 0;
							right: 0;
						}

						.icon-d {
							width: 16px;
							height: 16px;
						}
					}
				}
			}
		}

		.coupon-s {
			max-height: 200px;
			overflow: auto;

			.coupon-grey {
				filter: grayscale(100%);
				/*fire*/
				-webkit-filter: grayscale(100%);
				/*chrome*/
				opacity: 0.6;
			}
		}
	}

	.linear-gradient {
		background: linear-gradient(180deg, #E3FFF2 0%, #FBFCFE 35%, #FFFFFF 100%);
		border-radius: 16px 16px 0px 0px;

		.bg-serve {
			margin: 24px auto 30px;
			display: block;
			width: 200px;
			height: 104px;
		}

		.items {
			margin-bottom: 20px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: space-between;
			align-items: center;

			.item {
				width: 166px;
				height: 74px;
				background: rgba(0, 117, 74, 0.06);
				border-radius: 10px;
				position: relative;

				.text {
					position: absolute;
					top: 12px;
					left: 12px;
					width: 70px;
					height: 18px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 15px;
					color: #00754A;
					line-height: 18px;
				}

				.time {
					position: absolute;
					top: 34px;
					left: 12px;
					width: 110px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #333333;
					line-height: 14px;
				}

				.icon {
					position: absolute;
					top: 10px;
					right: 12px;
					width: 32px;
					height: 32px;
				}
			}

		}
	}

	.sku-sheet-dialog {
		padding: 14px;
		box-sizing: border-box;

		.icon-close {
			position: absolute;
			top: 14px;
			right: 14px;
			width: 12px;
			height: 12px;
			z-index: 1;
		}

		.h60 {
			height: 60px;
		}

		.goods {
			background-color: #ffffff;
			width: 100%;
			height: 60px;
			position: absolute;
			top: 14px;
			left: 14px;
			padding-bottom: 20px;

			.goods-img {
				width: 60px;
				height: 60px;
				border-radius: 6px;
			}

			.price {
				color: #FF4E4E;
				height: 20px;
				position: absolute;
				top: 2px;
				left: 74px;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: flex-end;
				justify-content: flex-start;
				align-items: flex-end;

				.symbol {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					line-height: 16px;
				}

				.num {
					height: 20px;
					font-family: DINAlternate, DINAlternate;
					font-weight: bold;
					font-size: 20px;
					line-height: 20px;
				}

				.small-num {
					font-size: 14px;
				}
			}

			.old-price {
				position: absolute;
				top: 26px;
				left: 74px;
				height: 12px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 10px;
				color: #999999;
				line-height: 12px;
				white-space: nowrap;
			}

			.text {
				position: absolute;
				top: 44px;
				left: 74px;
				width: 273px;
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #333333;
				line-height: 14px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}

		.addr {
			margin: 20px auto 0;
			width: 347px;
			background: #F7F7F7;
			border-radius: 10px;
			padding: 4px 10px;
			box-sizing: border-box;

			.addr-line {
				margin: 6px 0;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: center;
				align-items: center;

				.c3 {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 16px;
				}

				.m10 {
					margin-right: 10px;
				}

				.cg {
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #00754A;
					line-height: 14px;
				}

				.cbg {
					padding: 0 4px;
					height: 16px;
					background: #00754A;
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #FFFFFF;
					line-height: 16px;
				}

				.flex1 {
					flex: 1;
				}

				.icon {
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}

				.icon-arrow {
					width: 12px;
					height: 12px;
				}

				.text {
					max-width: 300px;
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #333;
					line-height: 16px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.c6 {
					color: #666;
				}
			}
		}

		.spec {
			.spec-title {
				margin: 20px 0 4px 0;
				height: 18px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #333333;
				line-height: 18px;
			}

			.cont-items {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				align-content: center;
				align-items: center;
				justify-content: flex-start;

				.cont-item {
					margin: 8px 8px 0 0;
					padding: 8px 10px;
					background: #F7F7F7;
					border-radius: 6px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #666666;
					position: relative;

					.goods-none {
						position: absolute;
						top: -6px;
						right: 0;

						.icon-none {
							width: 32px;
							height: 18px;
						}

						.text {
							position: absolute;
							top: 0;
							left: 50%;
							transform: translateX(-50%);
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							height: 18px;
							line-height: 16px;
							font-size: 10px;
							color: #FFFFFF;
							text-align: center;
							white-space: nowrap;
						}
					}
				}

				.cont-item-s {
					background: rgba(0, 117, 74, 0.06);
					border: 1px solid #00754A;
				}
			}
		}

		.h20 {
			height: 20px;
		}

		.sku-key-val {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
			height: 36px;

			.flex1 {
				flex: 1;
			}

			.sku-key {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
				line-height: 16px;
			}

			.num-step {}

			.sku-val {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;
				line-height: 16px;
			}

			.green {
				color: #00754A;
			}

			.red {
				color: #FF4E4E;
			}

			.icon-arrow {
				margin-left: 2px;
				width: 12px;
				height: 12px;
			}
		}

		.h80 {
			height: 80px;
		}

		.next-box {
			width: 375px;
			position: absolute;
			left: 0;
			bottom: 10px;
			background-color: #ffffff;

			.next-step {
				width: 375px;
				height: 30px;
				background: rgba(0, 117, 74, 0.06);
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #00754A;
				line-height: 30px;
				text-align: center;
			}

			.next-btn {
				margin: 5px auto;
				width: 355px;
				height: 40px;
				background: #00754A;
				border-radius: 10px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 15px;
				color: #FFFFFF;
				line-height: 40px;
				text-align: center;
			}

			.none {
				background: #CCCCCC;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/order/detail.vue